import React, {
    useState
} from "react";

import { Button } from "@mui/material";
import { CreateLocationDialog } from "./CreateLocationDialog";

type CreateLocationButtonProps = {
    createLocation: (locationName: string, locationImages?: Blob[]) => (void | Promise<void>);
    buttonProps?: React.ComponentProps<typeof Button>;
    icon?: React.ReactNode;
    text?: string;
};

export const CreateLocationButton = ({
    createLocation,
    buttonProps,
    icon,
    text = "Add Location",
}: CreateLocationButtonProps) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const handleOpen = () => {
        setIsDialogOpen(true);
    };

    const handleClose = () => {
        setIsDialogOpen(false);
    };

    return (
        <>
            <Button
                onClick={handleOpen}
                {...buttonProps}
                startIcon={icon}
            >
                {text}
            </Button>
            <CreateLocationDialog
                open={isDialogOpen}
                onClose={handleClose}
                createLocation={createLocation}
            />
        </>
    );
};